interface RealtimeFlowGate {
  flagEnabled: boolean;
  hasRealtimeUrl: boolean;
  hasInjectedPageData: boolean;
  isLoadingAuth: boolean;
  hasViewerTier: boolean;
}

/**
 * Whether /flow uses the realtime flow socket instead of the legacy queries.
 *
 * A page with injected data (the email screenshot server sets `window.injectedPageData`) renders
 * exactly that snapshot. On 2026-10-26, with the realtime flow on in production, the screenshot
 * browser opened the socket and FlowPageContainer joined realtime ticker fields onto the injected
 * rows: every sector in the email tables went blank and Momentum changed. The dark pool feed
 * already skips injected pages (`realtimeDpEnabled` in FlowPageContainer).
 */
export const isRealtimeFlowEnabled = ({
  flagEnabled,
  hasRealtimeUrl,
  hasInjectedPageData,
  isLoadingAuth,
  hasViewerTier,
}: RealtimeFlowGate): boolean =>
  flagEnabled && hasRealtimeUrl && !hasInjectedPageData && !isLoadingAuth && hasViewerTier;
